/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ResolveIdentitySecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ResolveIdentityRequest = {
  /**
   * The identity URN to resolve, in the form '<kind>:<id>'. Kind is one of 'user' (Speakeasy user id), 'email', 'external' (the external user id an agent reported), 'apikey', or 'agent'. Callers pass whichever identifier they hold; every URN for the same subject resolves to the same identity.
   */
  urn: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ResolveIdentitySecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ResolveIdentitySecurity$outboundSchema: z.ZodMiniType<
  ResolveIdentitySecurity$Outbound,
  ResolveIdentitySecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function resolveIdentitySecurityToJSON(
  resolveIdentitySecurity: ResolveIdentitySecurity,
): string {
  return JSON.stringify(
    ResolveIdentitySecurity$outboundSchema.parse(resolveIdentitySecurity),
  );
}

/** @internal */
export type ResolveIdentityRequest$Outbound = {
  urn: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ResolveIdentityRequest$outboundSchema: z.ZodMiniType<
  ResolveIdentityRequest$Outbound,
  ResolveIdentityRequest
> = z.pipe(
  z.object({
    urn: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function resolveIdentityRequestToJSON(
  resolveIdentityRequest: ResolveIdentityRequest,
): string {
  return JSON.stringify(
    ResolveIdentityRequest$outboundSchema.parse(resolveIdentityRequest),
  );
}
